import * as EmailClients from 'InboxConnectUtils/constants/EmailClients';
const ProviderTypes = {
  gmail: EmailClients.gmail.key,
  outlook365: EmailClients.outlook365.key,
  outlook365GccHigh: EmailClients.outlook365GccHigh.key,
  imap: EmailClients.imap.key,
  exchange: EmailClients.exchange.key
};
export default ProviderTypes;